import React, { useEffect, useState } from 'react';
// Importer le fichier JSON localement
import jsonData from '../../json-server/db.json'; // Assurez-vous que le chemin est correct

const SkillsSection = () => {
  const [skills, setSkills] = useState(null);

  // Charger les compétences depuis le JSON
  useEffect(() => {
    if (jsonData.skills) {
      setSkills(jsonData.skills);
    }
  }, []);

  // Si les données sont encore en train de charger
  if (!skills) {
    return <div>Loading...</div>;
  }

  return (
    <div className="skills-section">
      <h2>{skills.title}</h2>

      {/* Affichage des compétences générales */}
      <div className="skills-items">
        {skills.items.map((item, index) => (
          <div key={index} className="skill-item">
            <i className={`icon ${item.icon}`} />
            <h3>{item.value}</h3>
            <p>{item.label}</p>
            <p>{item.description}</p>
          </div>
        ))}
      </div>

      {/* Affichage des compétences de progression */}
      <div className="skills-progress">
        {skills.skillsProgress.map((skill, index) => (
          <div key={index} className="skill-progress-item">
            <h3>{skill.title}</h3>
            <div className="progress-bar" style={{ width: `${skill.progress}%` }}>
              <span>{skill.progress}%</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SkillsSection;
